import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter } from '../../../adapter/Adapter.mjs';
import { get_StringAdapter1plpsgiy8rwhj as get_StringAdapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { BeginDiscordOAuthInput22qiqfp1mhdpr as BeginDiscordOAuthInput } from '../BeginDiscordOAuthInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BeginDiscordOAuthInput_InputAdapterClass;
function BeginDiscordOAuthInput_InputAdapter() {
  if (BeginDiscordOAuthInput_InputAdapterClass === VOID) {
    class $ {
      p40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      d6x(writer, customScalarAdapters, value) {
        writer.l4d('partyId');
        get_partyIdAdapter().q40(writer, customScalarAdapters, value.f6t_1);
        writer.l4d('challenge');
        get_StringAdapter().q40(writer, customScalarAdapters, value.g6t_1);
      }
      q40(writer, customScalarAdapters, value) {
        return this.d6x(writer, customScalarAdapters, value instanceof BeginDiscordOAuthInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'BeginDiscordOAuthInput_InputAdapter', VOID, VOID, [Adapter()]);
    BeginDiscordOAuthInput_InputAdapterClass = $;
  }
  return BeginDiscordOAuthInput_InputAdapterClass;
}
var BeginDiscordOAuthInput_InputAdapter_instance;
function BeginDiscordOAuthInput_InputAdapter_getInstance() {
  return BeginDiscordOAuthInput_InputAdapter_instance;
}
//region block: init
BeginDiscordOAuthInput_InputAdapter_instance = new (BeginDiscordOAuthInput_InputAdapter())();
//endregion
//region block: exports
export {
  BeginDiscordOAuthInput_InputAdapter_instance as BeginDiscordOAuthInput_InputAdapter_instance2cer7e6l955ce,
};
//endregion

//# sourceMappingURL=BeginDiscordOAuthInput_InputAdapter.mjs.map
